// @flow
import * as React from 'react';
import { connectAPI, connectWS } from 'speed-js-react';
import { type WebSocketClient } from 'speed-js-core';
import { connect } from 'react-redux';
import ProgressBar from 'esm-web-pro/components/ProgressBar';
import { withTheme } from 'styled-components';
import type { Task } from 'esm-web-pro/types/common';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import { hasOpenedPanels } from 'esm-web-pro/redux/side-panel';

type Props = {
    user?: Object,
    hasOpenedPanels?: boolean,
    theme?: Object,
    ws?: WebSocketClient,
    getRunningTasks: () => Promise<Object>,
};

type State = {
    tasks: Task[],
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    hasOpenedPanels: hasOpenedPanels(state),
});

@connect(mapStateToProps)
@connectWS
@withTheme
@connectAPI((apiClient: ApiClient, props: Props) => ({
    getRunningTasks: {
        send: () => apiClient.resources.celeryTasks.getRunningTasksForUser(),
        success: (response) => ({
            initialTasks: response,
        }),
    },
}))
class UserTasksProgress extends React.Component<Props, State> {
    static defaultProps = {
        ws: {},
        user: null,
        theme: {},
        hasOpenedPanels: false,
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            tasks: [],
        };
    }


    componentDidMount(): void {
        const { ws, getRunningTasks, user } = this.props;

        if (user) {
            getRunningTasks().then((results) => {
                this.setState({
                    tasks: results.map((t) => JSON.parse(t.result)),
                });
            });

            ws.subscribe({
                'user-tasks': (data: Object) => this.setTasksState(data),
            });
        }
    }

    componentDidUpdate(prevProps: $ReadOnly<Props>): void {
        const { ws, user, getRunningTasks } = this.props;

        if (!user && prevProps.user) {
            ws.unSubscribe(['user-tasks']);
            this.resetTasksState();
        }

        if (user && !prevProps.user) {
            getRunningTasks().then((results) => {
                this.setState({
                    tasks: results.map((t) => JSON.parse(t.result)),
                });
            });

            ws.subscribe({
                'user-tasks': (data: Object) => this.setTasksState(data),
            });
        }
    }

    componentWillUnmount(): void {
        const { ws } = this.props;
        ws.unSubscribe(['user-tasks']);
    }

    resetTasksState = () => {
        this.setState({ tasks: [] });
    };

    setTasksState = (data: Task) => {
        this.setState((prevState: State) => {
            if (prevState.tasks.find((t) => t.task_id === data.task_id)) {
                return {
                    ...prevState,
                    tasks: prevState.tasks.map((t) => {
                        if (t.task_id === data.task_id) {
                            return {
                                ...t,
                                ...data,
                            };
                        }
                        return t;
                    }),
                };
            }
            return {
                ...prevState,
                tasks: prevState.tasks.concat({ ...data }),
            };
        });
    };


    render() {
        const {
            user, theme, hasOpenedPanels: hasOpenedPanelsProp,
        } = this.props;

        const { tasks } = this.state;


        return user ? (
            <>
                {tasks.filter((t) => t.progress < 100 || t.event === 'TASK_ERROR').map((task, index) => (
                    <ProgressBar
                        key={task.task_id}
                        label={task.task_name || ''}
                        progress={task.progress}
                        description={task.description}
                        index={index}
                        color={theme.global.colors.brand}
                        error={task.event === 'TASK_ERROR'}
                        hasOpenedPanels={hasOpenedPanelsProp}
                    />
                ))}
            </>
        ) : null;
    }
}

export default UserTasksProgress;
